module.exports = __webpack_public_path__ + "img/20190620162532358.47b41316.png";